module.exports = __webpack_public_path__ + "static/media/logo01.e85bd0fd.svg";